import { Component, Input, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';

import { MealPlanTemplateCreateComponent } from 'app/admin/public-templates/template-create/template-create.component';
import { MealPlan } from '../../../../@core/interfaces/common/CalorieFriend/plan';

/**
 * Component for 'Generate Template' csutom field / cell of ng2 smart table.
 */
@Component({
  template: `<button
    i18n="@@Generate"
    class="btn btn-primary"
    (click)="onGenerateTemplate()"
  >
    Generate
  </button>`,
})
export class TemplateGenerateComponent implements OnInit {
  @Input() value: any;

  private plan: MealPlan = null;

  constructor(private dialogService: NbDialogService) {}

  ngOnInit(): void {
    this.plan = this.value.ThePlan;
  }

  onGenerateTemplate(): void {
    this.dialogService.open(MealPlanTemplateCreateComponent, {
      closeOnEsc: false,
      context: { templatePlan: this.plan },
    });
  }
}
